module.exports = __webpack_public_path__ + "img/img4.89bb9d18.png";